<template>
  <div id="home-page">

    <div id="fullpage" >
      <div class="section">
        <hero-slider v-for="(slide, key) in slides" :key="key" :heading="slide.heading" :subHeading="slide.subHeading" :content="slide.content" :background="slide.background"/>
      </div>
      <div v-for="(section, index) in sections" class="section" :class="{'fp-auto-height': section.cta, 'align-bottom': section.alignBottom, 'get-started': section.getStarted}" :style="{background: section.background}">
        <app-section
          :index="index"
          :heading="section.heading"
          :content="section.content"
          :btnText="section.btnText"
          :image="section.image"
          :order="section.order"
          :button="section.button"
          :enter="section.enter"
          :animEnter="section.animEnter"
          :animLeave="section.animLeave"
          :appFooter="section.appFooter"
          :title="section.title"
          :subTitle="section.subTitle"
          :getStarted="section.getStarted"
          :alignBottom="section.alignBottom"
        />
      </div>
      <div id="footer" class="section fp-auto-height">
        <app-footer />
      </div>
    </div>

    <ul id="sidebar-nav" class="hidden-xs">
      <li><a v-on:click.prevent.stop="navigate(1)" :class="{'active': nav.section1}" href="#">Home</a></li>
      <li><a v-on:click.prevent.stop="navigate(2)" :class="{'active': nav.section2}" href="#">iOS App</a></li>
      <li><a v-on:click.prevent.stop="navigate(4)" :class="{'active': nav.section4}" href="#">Android App</a></li>
      <li><a v-on:click.prevent.stop="navigate(5)" :class="{'active': nav.section5}" href="#">Apple iPad</a></li>
      <li><a v-on:click.prevent.stop="navigate(7)" :class="{'active': nav.section7}" href="#">Android Tablet</a></li>
      <li><a v-on:click.prevent.stop="navigate(8)" :class="{'active': nav.section8}" href="#">Smart Watch</a></li>
      <li><a v-on:click.prevent.stop="navigate(9)" :class="{'active': nav.section9}" href="#">Get Started</a></li>
    </ul>

  </div>
</template>

<script>
  import HeroSlider from '@/components/HeroSlider'
  import AppSection from '@/components/AppSection'
  import AppFooter from '@/components/AppFooter'

  export default {
    name: 'home-page',
    components: {
      HeroSlider,
      AppSection,
      AppFooter
    },
    data () {
      return {
        slides: [
          {
            heading: 'We Build <span style="color: limegreen">Mobile Apps</span> Designed to Amaze.',
            subHeading: '15 years Experience in Developing Excellence',
            background:  require('../assets/slide1-bg.png'),
          },
          {
            heading: 'Gorgeous Design <br> Smooth Functionality',
            content: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
            background:  require('../assets/slide2-bg.jpg')
          }
        ],
        sections: [
          {
            heading: 'Heading',
            content: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco.',
            image: require('../assets/white-phone.png'),
            button: 'Learn More',
            background: 'radial-gradient(circle at center, #4b4b4b 0%,#000000 100%)',
            enter: false,
            animEnter: 'bounceInDown',
            animLeave: 'bounceOutDown'
          },
          {
            title: '<span style="color: limegreen; font-weight: 700">Ready</span> to get things going?',
            btnText: 'Start Now',
            background: "url('/static/gears.jpg') no-repeat center center",
            cta: true,
            enter: false
          },
          {
            heading: 'Heading',
            content: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco.',
            image: require('../assets/black-phone.png'),
            button: 'Learn More',
            background: 'radial-gradient(circle at center, #4b4b4b 0%,#0b1222 100%)',
            // order: -1,
            enter: false,
            animEnter: 'bounceInUp',
            animLeave: 'bounceOutDown'
          },
          {
            heading: 'Heading',
            content: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco.',
            image: require('../assets/white-tablet.png'),
            button: 'Learn More',
            background: 'radial-gradient(circle at center, #33223b 0%,#0b1122 100%)',
            enter: false,
            animEnter: 'bounceInDown',
            animLeave: 'bounceOutDown'
          },
          {
            title: '<span style="color: limegreen; font-weight: bold">Ready</span> to start building your app?',
            btnText: 'Start Now',
            background: "url('/static/gears.jpg') no-repeat center center",
            cta: true,
            enter: false
          },
          {
            heading: 'Heading',
            content: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco.',
            image: require('../assets/black-tablet.png'),
            button: 'Learn More',
            background: 'radial-gradient(circle at center, #3a222a 0%,#0b1222 100%)',
            enter: false,
            animEnter: 'bounceInUp',
            animLeave: 'bounceOutDown'
          },
          {
            heading: 'Heading',
            content: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco.',
            image: require('../assets/iwatch.png'),
            button: 'Learn More',
            background: 'radial-gradient(circle at center, #273a22 0%,#0b1222 100%)',
            alignBottom: 'true',
            enter: false,
            animEnter: 'bounceInUp',
            animLeave: 'bounceOutDown'
          },
          {
            title: '<span style="color: white">Get Started Today<span>',
            subTitle: '<span style="color: white">Let our expert teams create your next technology project.</span>',
            btnText: 'Get Started Now',
            image: require('../assets/gadgets.png'),
            background: 'radial-gradient(circle at top, #1d6077 20%,#0b1222 80%)',
            getStarted: 'true',
            // appFooter: 'true',
            enter: false,
            animEnter: 'zoomIn',
            // animLeave: 'slideOutDown'
          },
        ],
        nav: {
          section1: false,
          section2: false,
          section3: false,
          section4: false,
          section5: false,
          section6: false,
          section7: false,
          section8: false,
          section9: false,
          section10: false,
        },
        timer: ''
      }
    },
    methods: {
      navigate(index) {
        $.fn.fullpage.moveTo(index);
      },
      moveSlider(direction) {
        (direction == 'right') ?  $.fn.fullpage.moveSlideRight() : $.fn.fullpage.moveSlideLeft();
      }
    },
    mounted() {
      let vm = this;

      if($('html').hasClass('fp-enabled')){
          $.fn.fullpage.destroy('all');
      }

      $('#fullpage').fullpage({
        // paddingTop: '80px',
        scrollOverflow: true,
        slidesNavigation: true,
        controlArrows: false,
        loopHorizontal: false,
        // css3: false,
        // responsiveHeight: 500,
        sectionsColor : ['#000', '#000'],
        afterLoad: function(anchorLink, index) {
          vm.nav['section' + index] = true;
          (index == 1 || index == 9 || index == 10) ? $('#sidebar-nav').fadeOut() : $('#sidebar-nav').fadeIn()
          if (index == 1 || index == 10) return
          vm.sections[index - 2].enter = true;
      	},
        onLeave: function(index, nextIndex, direction){
          vm.nav['section' + index] = false;
          if (index == 1) return
          // vm.sections[index - 2].enter = false;

      	},
        afterRender: function() {
          vm.timer = setTimeout(function() {
            vm.moveSlider('right');
          }, 10000);
        },
        onSlideLeave: function(anchorLink, index, slideIndex, direction, nextSlideIndex) {
          clearTimeout(vm.timer);
          vm.timer = setTimeout(function() {
            (direction == 'right') ? vm.moveSlider('left') : vm.moveSlider('right');
          }, 10000);
        }
      });
    }
  }
</script>

<style scoped lang="sass">
  #sidebar-nav
    font-family: "Roboto", sans-serif
    font-weight: 300
    position: fixed
    z-index: 9
    top: 50%
    left: calc(50% + 410px)
    @media screen and (max-width: 1199px)
      left: calc(50% + 310px)
    @media screen and (max-width: 991px)
      left: calc(50% + 210px)
    transform: translateY(-50%)
    // transform: translate(-50%, -50%)
    direction: rtl
    line-height: 3em
    color: rgba(255,255,255,.1)
    // font-size: 16px
    font-size: .9em
    list-style: none
    li
      margin-right: 30px
      a
        color: rgba(255,255,255,.1)
        // font-size: 12px
        letter-spacing: 1px
        white-space: nowrap
        text-decoration: none
        position: relative
        transition: 400ms
        &:after
          font-family: "FontAwesome"
          content: ' '
          width: 7px
          height: 7px
          background: white
          opacity: .1
          font-size: .7em
          position: absolute
          right: -25px
          top: 5px
          border-radius: 50%
          transition: 300ms
        &:hover
          color: rgba(255,255,255,.5)
        &.active
          color: rgba(255,255,255,1)
          &:after
            transform: scale(1.3)
            opacity: 1

  .section
    background-size: cover !important
    .container
      // margin: 100px auto 0 auto

</style>



// WEBPACK FOOTER //
// HomePage.vue?f40ad4a4